import { Avatar, Badge, Button, Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconLogout, IconUser } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import { SUBSCRIPTION_PLAN_LABELS, formatDaysLeft } from '@creativitas/shared';
import { initialsOf } from '@/components/domain/ParticipantChip';
import { useLogout, useSession } from '@/features/auth/useSession';

/** Header identity control: who is signed in, their state, and the way out. */
export function UserMenu() {
  const { user, access, isLoading } = useSession();
  const logoutMutation = useLogout();
  const navigate = useNavigate();

  if (isLoading) return null;

  if (!user) {
    return (
      <Group gap="xs">
        <Button variant="subtle" size="sm" onClick={() => void navigate('/login')}>
          Войти
        </Button>
        <Button size="sm" onClick={() => void navigate('/register')}>
          Регистрация
        </Button>
      </Group>
    );
  }

  const trialBadge =
    access?.trial.active && access.trial.daysLeft !== null
      ? `Пробный период: осталось ${formatDaysLeft(access.trial.daysLeft)}`
      : null;

  return (
    <Group gap="sm" wrap="nowrap">
      {trialBadge ? (
        <Badge variant="light" color="teal" visibleFrom="md">
          {trialBadge}
        </Badge>
      ) : access?.subscription.active && access.subscription.plan ? (
        <Badge variant="light" color="gold" visibleFrom="md">
          Тариф {SUBSCRIPTION_PLAN_LABELS[access.subscription.plan]}
        </Badge>
      ) : null}

      <Menu position="bottom-end" width={220}>
        <Menu.Target>
          <UnstyledButton>
            <Group gap="xs" wrap="nowrap">
              <Avatar radius="xl" size={32} color="teal">
                {initialsOf(user.displayName)}
              </Avatar>
              <Text size="sm" fw={600} visibleFrom="sm">
                {user.displayName}
              </Text>
              <IconChevronDown size={14} />
            </Group>
          </UnstyledButton>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>{user.email}</Menu.Label>
          <Menu.Item component={Link} to="/profile" leftSection={<IconUser size={15} />}>
            Профиль
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            color="red"
            leftSection={<IconLogout size={15} />}
            onClick={() => logoutMutation.mutate()}
          >
            Выйти
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
}
